module.exports = __webpack_public_path__ + "img/portfolio-5.70fae66f.jpg";